"use client";

import { useEffect, useMemo, useState } from "react";
import { useDocumentVisible } from "@local/utils/src/useDocumentVisible";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
interface UseDynamicFaviconOptions {
  favicon?: string;
  count?: number;
}
export const useDynamicFaviconAndTitle = ({
  favicon: rawFavicon,
  count = 0
}: UseDynamicFaviconOptions) => {
  const favicon = useMemo(() => rawFavicon ? getCdnUrl({
    src: rawFavicon
  }) : undefined, [rawFavicon]);
  const isTabVisible = useDocumentVisible();
  const faviconSize = 32;
  const [result, setResult] = useState<string | null>(null);

  // FAVICON
  const draw = () => {
    if (typeof document === "undefined") {
      return favicon;
    }
    const items = count > 0 ? count : 1;
    const canvas = document.createElement("canvas");
    canvas.setAttribute("width", `${faviconSize}`);
    canvas.setAttribute("height", `${faviconSize}`);
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      console.warn("Failed to get 2D context for favicon generation");
      return;
    }
    const img = document.createElement("img");
    img.setAttribute("crossorigin", "anonymous");
    if (favicon) {
      img.setAttribute("src", favicon);
    }
    img.onload = () => {
      ctx.drawImage(img, 0, 0, faviconSize, faviconSize);
      // Draw Notification Circle
      ctx.beginPath();
      ctx.arc(canvas.width - faviconSize / 3.6, canvas.height - faviconSize / 3.6, faviconSize / 3.6, 0, 2 * Math.PI);
      ctx.fillStyle = "#FF0000";
      ctx.fill();
      ctx.font = `bold ${faviconSize / 1.8}px arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      ctx.fillStyle = "white";
      ctx.textBaseline = "bottom";
      ctx.textAlign = "right";
      ctx.fillText(items.toString(), faviconSize - 6 / 2, faviconSize + 1,
      // This will prevent the text from going outside the favicon, instead it'll squeeze his with to fit in
      faviconSize);
      setResult(canvas.toDataURL("image/png"));
    };
  };
  const replace = (url: string) => {
    if (document) {
      const head = document.getElementsByTagName("head")[0];
      const links = head.getElementsByTagName("link");
      for (let i = links.length; --i >= 0;) {
        if (links[i].getAttribute("rel")?.length && /\bicon\b/i.test(links[i].getAttribute("rel")!)) {
          links[i].setAttribute("href", url);
        }
      }
    }
  };
  useEffect(() => {
    if (typeof document === "undefined" || !favicon) {
      return;
    }
    draw();
    if (isTabVisible) {
      replace(favicon);
    } else {
      replace(result ?? favicon);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favicon, isTabVisible, count, result]);
};